import { Injectable, NgZone } from '@angular/core';
import { DwHttpRequestUrlService, SessionStorage } from '@webdpt/framework';
import { DwNotificationService } from 'ng-quicksilver';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SseService {

  api: string;
  eventSource: EventSource;

  //Angular检测事件并正确执行底层逻辑
  constructor(private _zone: NgZone,
    public dwHttpRequestUrlService: DwHttpRequestUrlService,
    public sessionStorage:SessionStorage,
    private notification: DwNotificationService
  ) {
    this.notification.config({
      dwPlacement: 'bottomRight',
      dwBottom: '0',
      dwDuration:5000,
      // icon: '<i class="anticon anticon-info-circle-o"></i>',
      dwOnClose: function(params) {
        console.log("David Lee关闭内容:"+params);
      }
    })

    //if(this.sessionStorage.get("token")!=null)
    //{
      //console.log("David Lee:"+this.sessionStorage.get("token"));
    //}
  }

  setApi(api:string):void{

    this.api=api;
  }

  close(): void {

    if (typeof (EventSource) != 'undefined'&&(this.eventSource!=null)){

      this.eventSource.close();

    }

  }

  getFxEventSource(): Observable<any> {

    if (typeof (EventSource) == 'undefined'){

      return Observable.create(observer => {
            this._zone.run(() => {
              observer.error("不支持EventSource!");
            });
        });

    }
    
    const token:string = sessionStorage.getItem("token");

    const requestUrl:string = this.dwHttpRequestUrlService.getUrl(this.api, "connect/");

    const url:string =requestUrl.replace("restful/service","stream")+token;

    //不新建立eventSource,仅新增的订阅EventSource.CLOSED==2
    if((this.eventSource!=null) && (this.eventSource.readyState!=2)){

      return Observable.create(observer => {
           
        this.eventSource.onmessage = event => {
          this._zone.run(() => {
            observer.next(event);
          });
        };

        this.eventSource.onopen = event => {

          //this.notification.blank('开启消息推送', '测试', {
          //  dwDuration: 8000,
          //  dwPauseOnHover:true,
          // },);
          console.log("开启消息推送");

        };

        this.eventSource.addEventListener('connected', (event: MessageEvent) => {

          //this.notification.blank('已上线', '测试', {
          // dwDuration: 8000,
          // dwPauseOnHover:true
          //});

        });

        this.eventSource.addEventListener('disconnected', (event: MessageEvent) => {

          this.eventSource.close();

  
          //this.notification.blank('已下线', '测试', {
          //  dwDuration: 8000,
          //  dwPauseOnHover:true
          //});
          observer.complete();

        });
  
        // this.eventSource.close = () => {
          
        //   this.notification.blank('关闭消息推送', '测试', {
        //     dwDuration: 8000,
        //     dwPauseOnHover:true
        //    });
        //    observer.complete();
        //   console.log("关闭消息推送");
        // };

        this.eventSource.onerror = error => {
          this._zone.run(() => {
            observer.error(error);
            console.log("消息推送出错啦！");
          });
        };
      });

    }else{

      return Observable.create(observer => {
      
          this.eventSource =  new EventSource(url);
       
          this.eventSource.onmessage = (event: MessageEvent) => {
            this._zone.run(() => {

              //this.notification.blank('系统通知', event.data, {
              //  dwDuration: 8000,
              //  dwPauseOnHover:true
              // });

              observer.next(event.data);
            });
          };

          this.eventSource.onopen = (event: MessageEvent) => {

            // this.notification.blank('开启推送', event.data, {
            //   dwDuration: 8000,
            //   dwPauseOnHover:true
            // });

            console.log("David Lee:开启推送");
          };

          this.eventSource.addEventListener('connected', (event: MessageEvent) => {

            //this.notification.blank('上线啦', event.data, {
            // dwDuration: 8000,
            // dwPauseOnHover:true
            //});

            observer.complete();

 
          });

          this.eventSource.addEventListener('disconnected', (event: MessageEvent) => {


            //this.notification.blank('已下线', event.data, {
            //  dwPauseOnHover:true
            //});

            this.eventSource.close();

            observer.complete();

          });
    
          //测试
          // this.eventSource.close = () => {

          //   this.notification.blank('关闭推送', '测试', {
          //     dwDuration: 8000,
          //     dwPauseOnHover:true
          //   });

          //   console.log("关闭推送");

          //   observer.complete();
            
          // };

          this.eventSource.onerror = (event:MessageEvent) => {

            console.log("消息推送出错啦",event);

            this._zone.run(() => {
              observer.error(event.data);
            });
          };
        }
      );
    }
  }

  //For Test
  getServerSentEvent(url: string): Observable<any> {

      const requestUrl = this.dwHttpRequestUrlService.getUrl(this.api, url);

      return Observable.create(observer => {

        if (typeof (EventSource) !== 'undefined'){
          this.eventSource = new EventSource(requestUrl);

          this.eventSource.onmessage = event => {
            this._zone.run(() => {
              observer.next(event);
            });
          };

          this.eventSource.onopen = event => {

            console.log("开启推送");
          };

      
          this.eventSource.close = () => {
            console.log("关闭推送");
          };

          this.eventSource.onerror = error => {
            this._zone.run(() => {
              observer.error(error);
            });
          };
        }else{
          this._zone.run(() => {
            observer.error("不支持EventSource!");
          });
        }
    });
  }

}
